import PropTypes from 'prop-types';
import React from 'react';
import { useTheme } from 'styled-components';
import * as S from './styled';
export const STATE_IDLE = 'idle';
export const STATE_ANIMATE = 'animate';
export const STATE_ACTIVATED = 'activated';
export const STATES = [STATE_IDLE, STATE_ANIMATE, STATE_ACTIVATED];
export const RaisedHands = ({
  state
}) => {
  const theme = useTheme();
  return /*#__PURE__*/React.createElement(S.AnimatedIcon, {
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "juich-icoon",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement(S.Sprinkle, {
    state: state,
    theme: theme,
    stroke: "currentColor",
    strokeWidth: "2.3",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: "4",
    d: "m 21.875439,14.230819 -6.71745,-6.71745"
  }), /*#__PURE__*/React.createElement(S.Sprinkle, {
    state: state,
    theme: theme,
    stroke: "currentColor",
    strokeWidth: "2.3",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: "4",
    d: "M 31.853908,11.4784 V 1.9784003"
  }), /*#__PURE__*/React.createElement(S.Sprinkle, {
    state: state,
    theme: theme,
    stroke: "currentColor",
    strokeWidth: "2.3",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: "4",
    d: "m 41.717738,14.290618 6.71745,-6.7174498"
  }), /*#__PURE__*/React.createElement(S.Hand, {
    state: state,
    theme: theme,
    d: "M29.6,34.7 L29.4,34.5 C28,33.1 26.3,33.1 24.9,34.5 L21.7,37.6 C21.5,37.8 21.3,37.9 21.1,37.9 L21.1,22.4 C21.1,20.4 19.9,19.2 17.9,19.2 L17.6,19.2 C17.1,19.2 16.6,19.3 16.2,19.5 C15.8,18.2 14.7,17.5 13.2,17.5 L12.9,17.5 C11,17.5 9.8,18.6 9.7,20.4 C9.3,20.3 8.9,20.2 8.5,20.2 L8,20.2 C6,20.2 4.8,21.4 4.8,23.4 L4.8,28.8 C4.4,28.7 4,28.6 3.6,28.6 L3.2,28.6 C1.2,28.6 0,29.8 0,31.8 L0,32 L0,43.1 C0,44 0.3,44.8 0.9,45.4 L4.4,49 C4.6,49.2 4.7,49.5 4.7,49.9 L4.7,60.3 C4.7,61.1 5.3,61.7 6.2,61.7 L19.6,61.7 C20.4,61.7 21,61.1 21,60.3 L21,48.7 L21,48.5 C21,48.1 21.1,47.8 21.3,47.6 L29.4,39.5 L29.6,39.3 C31,37.8 31,36.1 29.6,34.7 Z M19,48.3 L19,59.7 L6.8,59.7 L6.8,49.9 C6.8,49 6.5,48.2 5.9,47.6 L2.3,44 C2.1,43.8 2,43.5 2,43 L2,31.7 C2,30.7 2.7,30.4 3.3,30.4 L3.5,30.4 C4.1,30.4 4.8,30.6 4.8,31.7 L4.8,32.5 L4.8,32.5 L4.8,39 L6.8,39 L6.8,32.5 L6.8,32.5 L6.8,31.9 L6.8,23.5 L6.8,23.3 C6.8,22.3 7.5,22 8.1,22 L8.3,22 C8.9,22 9.6,22.2 9.6,23.3 L9.6,24.1 L9.6,24.1 L9.6,37 L11.6,37 L11.6,24.1 L11.6,24.1 L11.6,23.5 L11.6,20.8 L11.6,20.6 C11.6,19.6 12.3,19.3 12.9,19.3 L13,19.3 C13.6,19.3 14.3,19.5 14.3,20.6 L14.3,22.3 L14.3,23.1 L14.3,34.9 L16.3,34.9 L16.3,23 L16.3,22.3 C16.3,21.3 17,21 17.6,21 L17.8,21 C18.4,21 19.1,21.2 19.1,22.3 L19.1,39.8 L20.9,39.8 C21.8,39.8 22.6,39.5 23.2,38.9 L26.3,35.8 C27,35.1 27.7,35.4 28.1,35.8 L28.3,36 C28.7,36.4 29,37 28.3,37.8 L19.9,46 C19.3,46.6 19.1,47.4 19,48.3 Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement(S.Hand, {
    state: state,
    theme: theme,
    d: "M34,39.2 L34.2,39.4 L42.3,47.5 C42.5,47.7 42.6,48 42.6,48.4 L42.6,48.6 L42.6,60.3 C42.6,61.1 43.2,61.7 44,61.7 L57.4,61.7 C58.2,61.7 58.9,61.1 58.9,60.3 L58.9,49.9 C58.9,49.5 59,49.2 59.2,49 L62.8,45.4 C63.4,44.8 63.6,44 63.7,43.1 L63.7,32 L63.7,31.7 C63.7,29.7 62.5,28.5 60.5,28.5 L60,28.5 C59.6,28.5 59.2,28.6 58.8,28.7 L58.8,23.3 C58.8,21.3 57.6,20.1 55.6,20.1 L55.3,20.1 C54.8,20.1 54.4,20.2 54.1,20.3 C54,18.5 52.8,17.4 50.9,17.4 L50.6,17.4 C49.1,17.4 48,18.2 47.6,19.4 C47.2,19.2 46.7,19.1 46.2,19.1 L45.9,19.1 C43.9,19.1 42.7,20.3 42.7,22.3 L42.7,37.8 C42.4,37.8 42.2,37.7 42.1,37.5 L38.9,34.4 C37.5,33 35.8,33 34.4,34.4 L34,34.7 C32.6,36.1 32.6,37.8 34,39.2 Z M43.7,46 L35.4,37.8 C34.7,37.1 35,36.4 35.4,36 L35.6,35.8 C36,35.4 36.6,35.1 37.4,35.8 L40.5,38.9 C41.1,39.5 41.9,39.7 42.8,39.8 L44.6,39.8 L44.6,22.3 C44.6,21.3 45.3,21 45.9,21 L46,21 C46.6,21 47.3,21.2 47.3,22.3 L47.3,23 L47.3,34.9 L49.3,34.9 L49.3,23.1 L49.3,22.3 L49.3,20.6 C49.3,19.6 50,19.3 50.6,19.3 L50.8,19.3 C51.4,19.3 52.1,19.5 52.1,20.6 L52.1,20.8 L52.1,23.5 L52.1,24.1 L52.1,24.1 L52.1,37 L54.1,37 L54.1,24.1 L54.1,24.1 L54.1,23.3 C54.1,22.3 54.8,22 55.4,22 L55.6,22 C56.2,22 56.9,22.2 56.9,23.3 L56.9,23.5 L56.9,32 L56.9,32.6 L56.9,32.6 L56.9,39 L58.9,39 L58.9,32.5 L58.9,32.5 L58.9,31.7 C58.9,30.7 59.6,30.4 60.2,30.4 L60.4,30.4 C61,30.4 61.7,30.6 61.7,31.7 L61.7,43 C61.7,43.4 61.6,43.7 61.4,43.9 L57.8,47.5 C57.2,48.1 57,48.9 56.9,49.8 L56.9,59.6 L44.5,59.6 L44.5,48.2 C44.5,47.4 44.2,46.6 43.7,46 Z",
    fill: "currentColor"
  })));
};
RaisedHands.propTypes = {
  state: PropTypes.oneOf(STATES)
};
RaisedHands.defaultProps = {
  state: STATE_ANIMATE
};